export default "__VITE_ASSET__DkgG371h__"